/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const candidateEventResponseTypeSchema = z.enum([
	'invitation_created',
	'invitation_sent',
	'invitation_superseded',
	'invitation_expired',
	'booking_confirmed',
	'booking_cancelled',
	'stage_changed',
	'email_sent',
	'email_received',
	'whatsapp_sent',
	'whatsapp_received',
	'applied',
])

export type CandidateEventResponseTypeSchema = z.infer<typeof candidateEventResponseTypeSchema>
